import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSubCategoryAction = createAsyncThunk(
    'get-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-sub-category?is_deleted=${data?.is_deleted}&cat_id=${data?.cat_id}&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSubCategorySlice = createSlice({
    name: 'get-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSubCategoryReducer = getSubCategorySlice.reducer    